import { WhatsappMessage } from "../types";
import { cn } from "@/lib/utils";

type MessageBubbleProps = {
  message: WhatsappMessage;
};

const statusLabel: Record<string, string> = {
  received: "Recebida",
  sent: "Enviada",
  delivered: "Entregue",
  read: "Lida",
  failed: "Falha",
};

export function MessageBubble({ message }: MessageBubbleProps) {
  const outbound = message.direction === "outbound";
  const textBody = (message.textBody ?? "").trim();
  const timestamp = resolveTimestamp(message);

  return (
    <div
      className={cn("flex w-full", outbound ? "justify-end" : "justify-start")}
      data-message-id={message.id}
    >
      <div
        className={cn(
          "max-w-[85%] min-w-0 rounded-2xl px-3 py-2 text-sm shadow-sm sm:max-w-[72%]",
          outbound
            ? "rounded-br-md bg-emerald-500 text-white"
            : "rounded-bl-md border border-slate-200 bg-white text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100",
        )}
      >
        <p className={cn("whitespace-pre-wrap break-words", !textBody && "italic")}>
          {textBody || `[${message.messageType}]`}
        </p>
        <div
          className={cn(
            "mt-1 flex items-center justify-end gap-2 text-[11px]",
            outbound ? "text-emerald-50/90" : "text-slate-500 dark:text-slate-400",
          )}
        >
          <span>{formatTime(timestamp)}</span>
          {outbound ? <span>{statusLabel[message.status] ?? message.status}</span> : null}
        </div>
      </div>
    </div>
  );
}

function resolveTimestamp(message: WhatsappMessage): string {
  return (
    message.readAt ??
    message.sentAt ??
    message.receivedAt ??
    message.createdAt ??
    new Date().toISOString()
  );
}

function formatTime(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "--:--";
  }
  return date.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
}
